import React, { useContext } from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import LocaleContext from '../../../constants/localization';
import GroupForm from '../GroupForm';
import { AccordionTrigger, AccordionContent } from 'components/common/Accordion'

const NewGroup = ({
  setName,
  setEmail,
  setResponsable,
  setDescription,
  setAccessToClassifiedInfo,
  handleSubmit,
  submitDisabled,
  openAccordions,
  setOpenAccordions,
}) => {
  const LS = useContext(LocaleContext);

  return (
    <Accordion.Root
      type="single"
      collapsible
      value={openAccordions}
      onValueChange={setOpenAccordions}
    >
      <Accordion.Item value="item-1">
        <AccordionTrigger>
          <div>
            <i className="fa fa-plus-square-o" />
            {LS.manageGroups.addGroup}
          </div>
        </AccordionTrigger>
        <AccordionContent>
          <form onSubmit={handleSubmit}>
            <GroupForm
              edit={false}
              setName={setName}
              setEmail={setEmail}
              setResponsable={setResponsable}
              setDescription={setDescription}
              setAccessToClassifiedInfo={setAccessToClassifiedInfo}
            ></GroupForm>
            <button
              className="button"
              type="submit"
              disabled={submitDisabled}
              style={{ marginTop: '12px' }}
            >
              {LS.manageGroups.addGroup}
            </button>
          </form>
        </AccordionContent>
      </Accordion.Item>
    </Accordion.Root>
  );
};

export default NewGroup;
